// Generated by https://quicktype.io

export class QuoteViewerQuote {
	BillingFrequency2__c: string;
	BillingName: string;
	Billing_Frequency2__c: string;
	Contract_Term__c: number;
	DepositAmount__c: number;
	DepositPercent__c: number;
	DirectPurchasePaymentTerms__c: string;
	EstimatedStartDate__c: string;
	ExpirationDate: string;
	Extend_Existing_Contract__c: boolean;
	FocusCloudPlus__c: boolean;
	FocusCloudPlusSubscription__c: number;
	Id: string;
	LastModifiedDate: string;
	Name: string;
	Opportunity: Opportunity;
	PaymentTermNotes__c: string;
	Payment_Processing_Rate__r?: PaymentProcessingRate;
	QuoteLineItems: QuoteLineItems;
	QuoteNumber: string;
	Status: string;
	Subtotal: number;
	TotalEquipmentProfessionalServices__c: number;
	TotalEquipment__c: number;
	TotalSubscription__c: number;
	attributes: Attributes;

	public constructor(init?: Partial<QuoteViewerQuote>) {
		Object.assign(this, init);
	}
}

export class Opportunity {
	attributes: Attributes;
	Id: string;
	Name: string;
	Opty_Contact__r: OptyContactR;
	RecordTypeId: string;
	Account: Account;
	Owner: Owner;
}

export class Account {
	attributes: Attributes;
	Id: string;
	Name: string;
	BillingStreet: null;
	BillingCity: null;
	BillingState: null;
	BillingPostalCode: null;
	Phone: null;
	ShippingStreet: null;
	ShippingCity: null;
	ShippingState: null;
	ShippingPostalCode: null;
}

export class Owner {
	FirstName: string;
	LastName: string;
	Email: string;
	MobilePhone: string;
}

export class Attributes {
	type: Type;
	url: string;
}

export enum Type {
	Account = "Account",
	Contact = "Contact",
	Opportunity = "Opportunity",
	Product2 = "Product2",
	Quote = "Quote",
	QuoteLineItem = "QuoteLineItem",
}

export class OptyContactR {
	attributes: Attributes;
	Email: string;
	FirstName: string;
	LastName: string;
	MobilePhone: string;
}

export class QuoteLineItems {
	totalSize: number;
	done: boolean;
	records: QuoteLineItemRecord[];
}

export class QuoteLineItemRecord {
	attributes: Attributes;
	Id: string;
	SortOrder: number;
	Quantity: number;
	UnitPrice: number;
	Subtotal: number;
	Item_Total__c: number;
	Product2Id: string;
	LineNumber: string;
	Item_Description__c: string;
	Extended_Price__c: number;
	Discount: number | null;
	fw2__Discount_Amount__c: null;
	Discount_Friendly__c: null | string;
	fw2__Recurring__c: boolean;
	Product2: Product2;
	viewItemDetail: boolean;
}

export class PaymentProcessingRate {
	AMEX_Bin_Rate__c: number;
	AMEX_Tran_Fee__c: number;
	Batch_Fee__c: number;
	Device_Fee__c: number;
	Monthly_Service_Fee__c: number;
	Rate_note__c: string;
	VMCD_Bin_Rate__c: number;
	VMCD_Tran_Fee__c: number;
	RecordTypeId: string;
}

export class Product2 {
	Availability__c: null;
	Detailed_Description__c: string;
	DisplayUrl: string;
	Family: string;
	Filter_Group__c: null | string;
	Knowledge_URL__c: null | string;
	Mfr_Part_Number__c: null | string;
	Mfr_Warranty_Term__c: number | null;
	Name: string;
	ProductCode: null | string;
	Product_Image_Link__c: string;
	Product_Image__c: string;
	Product_Type__c: null | string;
	Taxable__c: boolean;
	Type__c: TypeC;
	attributes: Attributes;
}

export enum TypeC {
	Equipment = "Equipment",
	Implementation = "Implementation",
	Monthly = "Monthly",
	None = "None",
}

export class QuoteAcceptance {
	accountId: string;
	dateTimeSigned: string;
	emailAddress: string;
	firstName: string;
	lastName: string;
	opportunityId: string;
	paymentTermsAcceptance: boolean;
	phoneNumber: string;
	quoteId: string;
	submitted: boolean;
	termsAcceptance: boolean;
	title: string;
	viewerID: string;
	ipAddress: string;
	deviceDetail: any;
	quoteNumber: string;

	public constructor(init?: Partial<QuoteAcceptance>) {
		Object.assign(this, init);
	}
}

export class SalesforcePaymentProfile {
	attributes: Attributes;
	Accepted_Terms_Online__c: boolean;
	Bank_ABA_Routing_Plain_Text__c?: string;
	Bank_Account_Plain_Text__c?: string;
	Bank_Name__c?: string;
	Card_Security_Code__c: string;
	CreatedById: string;
	CreatedDate: Date;
	Credit_Card_Plain_Text__c: string;
	fw1__Account__c: string;
	fw1__Authorization_ID__c?: string;
	fw1__Bank_ABA_Code__c?: string;
	fw1__Bank_Account_Number__c?: string;
	fw1__Billing_City__c: string;
	fw1__Billing_Country__c: string;
	fw1__Billing_State__c: string;
	fw1__Billing_Street__c: string;
	fw1__Billing_Zip__c: string;
	fw1__Card_Or_Bank_ID__c?: string;
	fw1__Contact_Name__c?: string;
	fw1__Contact__c?: string;
	fw1__CreditCardNumber__c: string;
	fw1__CreditCardType__c: string;
	fw1__Credit_Card_Expiration_Date__c: string;
	fw1__Credit_Card_Expiration_Days__c: number;
	fw1__Customer_Profile_ID__c?: string;
	fw1__Email__c?: string;
	fw1__ExpiryMonth__c: string;
	fw1__ExpiryYear__c: string;
	fw1__First_Name__c: string;
	fw1__Is_Business_Checking__c: boolean;
	fw1__Last_Four_Digits__c: string;
	fw1__Last_Name__c: string;
	fw1__Name_On_Account__c?: string;
	fw1__Payment_Method_ID__c?: string;
	fw1__Payment_Processor__c?: string;
	fw1__Phone__c?: string;
	fw1__ProfileID__c: string;
	fw1__Profile_Type__c: string;
	fw1__Requesting_Entity__c?: string;
	fw1__Request_Token__c?: string;
	fw1__Tokenization_Message__c?: string;
	fw1__Token_Payment_Method__c?: string;
	fw1__Token__c?: string;
	fw1__Type__c: string;
	fw1__Unverified__c: boolean;
	fw1__UseAsDefault__c: boolean;
	Id: string;
	IsDeleted: boolean;
	LastModifiedById: string;
	LastModifiedDate: Date;
	Name: string;
	OwnerId: string;
	Payment_Notes__c: string;
	Recurring_Billing__c?: string;

	public constructor(init?: Partial<SalesforcePaymentProfile>) {
		Object.assign(this, init);
	}
}
